import CourseMoreOptions from "./courseMoreOptions/CourseMoreOptions"
import MyCourseItem from "../MyCourseItem";
import classes from "./MyCourseItemWithOptions.module.css";

const MyCourseItemWithOptions = ({ course }) => {

    return (
        <div className={classes.CourseItemWraper}>
            <CourseMoreOptions course={course} />
            <MyCourseItem course={course} />
        </div>

    );
};

export default MyCourseItemWithOptions; 